import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from './LoginPage';
// Registration disabled: users are created via CLI (server/scripts/create-user.js).
// To re-enable, uncomment: import RegisterPage from './RegisterPage';
// import RegisterPage from './RegisterPage';
import { Loader2 } from 'lucide-react';

// AuthGate wraps the app. Shows login/register when not authenticated.
const AuthGate = ({ children }) => {
  const { isAuthenticated, loading, onLoginSuccess } = useAuth();
  // To re-enable registration, uncomment: const [page, setPage] = useState('login');
  // const [page, setPage] = useState('login');

  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <div className="text-center">
          <Loader2 size={40} className="animate-spin text-blue-500 mx-auto mb-4" />
          <p className="text-txt-secondary">Caricamento...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Registration disabled: users are created via CLI (scripts/create-user.js).
    // To re-enable, uncomment the register block and pass onShowRegister to LoginPage.
    // if (page === 'register') {
    //   return <RegisterPage onShowLogin={() => setPage('login')} />;
    // }
    return <LoginPage onLoginSuccess={onLoginSuccess} onShowRegister={() => {}} />;
  }

  return children;
};

export default AuthGate;
